import DateField from "components/Field/DateField";
import FirstNameField from "components/Field/FirstNameField";
import IntegerField from "components/Field/IntegerField";
import LastNameField from "components/Field/LastNameField";
import PasswordAndConfirmField from "components/Field/PasswordAndConfirmField";
import PasswordField from "components/Field/PasswordField";
import UserNameField from "components/Field/UserNameField";
import PropTypes from "prop-types";
import React from "react";

export const fieldTypes = {
  userName: "USERNAME",
  firstName: "FIRSTNAME",
  lastName: "LASTNAME",
  // These are field type identifiers, not hardcoded credentials — S2068 false positive
  password: "PASSWORD", // NOSONAR javascript:S2068
  passwordAndConfirm: "PASSWORD_AND_CONFIRM", // NOSONAR javascript:S2068
  date: "DATE",
};

export const fieldsTimeOutValue = 300;

const Field = ({ type, propsObject }) => {
  let SpecificField;
  switch (type) {
    case fieldTypes.userName:
      SpecificField = UserNameField;
      break;
    case fieldTypes.firstName:
      SpecificField = FirstNameField;
      break;
    case fieldTypes.lastName:
      SpecificField = LastNameField;
      break;
    case fieldTypes.password:
      SpecificField = PasswordField;
      break;
    case fieldTypes.passwordAndConfirm:
      SpecificField = PasswordAndConfirmField;
      break;
    case fieldTypes.integer:
      SpecificField = IntegerField;
      break;
    case fieldTypes.date:
      SpecificField = DateField;
      break;
    default:
      return null;
  }

  return <SpecificField {...propsObject} />;
};

export default Field;

Field.propTypes = {
  type: PropTypes.string.isRequired,
  // props can be of any type, actual type checking is handled in the specific Dropdown components

  propsObject: PropTypes.objectOf(PropTypes.any).isRequired,
};
